import MenuComponent from '@/components/MenuComponent'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  components: {
    MenuComponent,
    BlocAuthenticated
  },
  data () {
    return {
      userAdminListLocked: [],
      loading: false,
      userToUnblock: '',
      otpGenerated: ''
    }
  },
  methods: {
    async getUserAdminListLocked () {
      this.loading = true
      this.$store.dispatch('user/getUserAdminListLocked').then(
        response => {
          this.loading = false
          this.userAdminListLocked = response
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async unblockUser (user) {
      this.userToUnblock = user
      this.userToUnblock.updateUser = this.$store.state.user.user.login
      if (confirm('Voulez vous vraiment réinitialiser le code personnel de : ' + this.userToUnblock.firstName + ' ' + this.userToUnblock.lastName + ' ( id = ' + this.userToUnblock.login + ' ) ?')) {
        this.loading = true
        this.$store.dispatch('user/unblockUserAdmin', this.userToUnblock.login + '_' + this.userToUnblock.updateUser).then(
          response => {
            this.otpGenerated = response
            this.userAdminListLocked = []
            this.getUserAdminListLocked()
            this.loading = false
          },
          error => {
            this.loading = false
            this.errorMessage = error.response
          }
        )
      }
    },
    format_date (value) {
      var moment = require('moment')
      moment.locale('fr')
      if (value) {
        return moment(value).format('DD MMM YYYY')
      }
    }
  },
  created () {
    if (!this.userAdminListLocked.length) {
      this.getUserAdminListLocked()
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Liste des administrateurs verrouillés'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
